// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AddchartIcon from '@mui/icons-material/Addchart';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ChairIcon from '@mui/icons-material/Chair';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import InventoryIcon from '@mui/icons-material/Inventory';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import SavingsIcon from '@mui/icons-material/Savings';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import SettingsIcon from '@mui/icons-material/Settings';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    AccountBalanceIcon,
    MenuBookIcon,
    AddchartIcon,
    LeaderboardIcon,
    CommentsDisabledIcon,
    AssessmentIcon,
    CardTravelIcon,
    ArrowCircleRightIcon,
    ArrowCircleLeftIcon,
    AddBoxIcon,
    ListAltIcon,
    ChairIcon,
    EventSeatIcon,
    InventoryIcon,
    ReportGmailerrorredIcon,
    SavingsIcon,
    JoinInnerIcon,
    AccessibilityIcon,
    LocalAtmIcon,
    AttachMoneyIcon,
    CreditCardIcon,
    CompareArrowsIcon,
    SettingsIcon
}

// ==============================|| CONTABILIDAD MENU ITEMS ||============================== //

const contabilidad = {
    id: 'contabilidad',
    title: '',
    type: 'group',
    children: [
        {
            id: 'contabilidadMainMenu',
            title: 'Contabilidad',
            type: 'collapse',
            icon: icoMenu.AccountBalanceIcon,
            children: [
                {
                    id: 'libro_diario',
                    title: 'Libro Diario',
                    type: 'item',
                    icon: icoMenu.MenuBookIcon,
                    url: '/user/libro-diario'
                },
                {
                    id: 'nuevo_asiento_contable',
                    title: 'Nuevo Asiento Contable',
                    type: 'item',
                    icon: icoMenu.AddchartIcon,
                    url: '/user/new-libro-diario'
                },
                {
                    id: 'listar_asientos_manuales',
                    title: 'Listar Asientos Manuales',
                    type: 'item',
                    icon: icoMenu.MenuBookIcon,
                    url: '/user/list-asientos-manuales-view'
                },
                {
                    id: 'mayorizacion',
                    title: 'Mayorización',
                    type: 'item',
                    icon: icoMenu.LeaderboardIcon,
                    url: '/user/mayorizacion-view'
                },
                {
                    id: 'cierre_periodos',
                    title: 'Cierre de periodos',
                    type: 'item',
                    icon: icoMenu.MenuBookIcon,
                    url: '/user/cierre-periodos'
                },
                {
                    id: 'cierre_ejercicio',
                    title: 'Cierre de ejercicio',
                    type: 'item',
                    icon: icoMenu.MenuBookIcon,
                    url: '/user/cierre-ejercicio'
                },
                {
                    id: 'anulaciones',
                    title: 'Anulaciones',
                    type: 'item',
                    icon: icoMenu.CommentsDisabledIcon,
                    url: '/user/list-anulaciones-view'
                },
                {
                    id: 'ats',
                    title: 'Ats',
                    type: 'item',
                    icon: icoMenu.AssessmentIcon,
                    url: '/user/ats-view'
                },
                {
                    id: 'cruce_comprobantes_sri',
                    title: 'Cruce comprobantes',
                    type: 'item',
                    icon: icoMenu.CompareArrowsIcon,
                    url: '/user/cruce-comprobantes'
                },
                {
                    id: 'cartera',
                    title: 'Cartera',
                    type: 'collapse',
                    icon: icoMenu.CardTravelIcon,
                    children: [
                        {
                            id: 'cuentas_por_pagar_cartera',
                            title: 'Cuentas por Pagar',
                            type: 'item',
                            icon: icoMenu.ArrowCircleRightIcon,
                            url: '/user/cartera-cuentas-pagar-view'
                        },
                        {
                            id: 'lista_egresos',
                            title: 'Lista Egresos',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-egresos-view'
                        },
                        {
                            id: 'nuevo_egreso_directo',
                            title: 'Nuevo egreso directo',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/nuevo-egreso-directo'
                        },
                        {
                            id: 'cruce_notas_credito',
                            title: 'Cruce notas de crédito',
                            type: 'item',
                            icon: icoMenu.CompareArrowsIcon,
                            url: '/user/cruce-notas-credito'
                        },
                        {
                            id: 'cuentas_cobrar_clientes',
                            title: 'Cuentas por Cobrar',
                            type: 'item',
                            icon: icoMenu.ArrowCircleLeftIcon,
                            url: '/user/cuentas-cobrar-clientes-cartera-view'
                        },
                        {
                            id: 'liquidacion_tarjetas_credito',
                            title: 'Liquidación tarjetas',
                            type: 'item',
                            icon: icoMenu.CreditCardIcon,
                            url: '/user/liquidacion-tarjetas-credito-view'
                        },
                        {
                            id: 'lista_cobros_clientes',
                            title: 'Recibos de cobro',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/lista-cobros-clientes-view'
                        },
                        {
                            id: 'lista_bancos_cobrar',
                            title: 'Nuevo Banco o Tarjeta',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-lista-bancos/0'
                        },
                        {
                            id: 'list_lista_bancos_cobrar',
                            title: 'Lista Bancos o Tarjetas',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-lista-bancos-tarjetas'
                        },
                        {
                            id: 'config_impresion_cheque',
                            title: 'Config. impresión cheque',
                            type: 'item',
                            icon: icoMenu.SettingsIcon,
                            url: '/user/config-impresion-cheque-view'
                        },
                    ]
                },
                {
                    id: 'activos',
                    title: 'Activos Fijos',
                    type: 'collapse',
                    icon: icoMenu.ChairIcon,
                    children: [
                        {
                            id: 'nuevo-activo-fijo',
                            title: 'Activos Fijos',
                            type: 'item',
                            icon: icoMenu.EventSeatIcon,
                            url: '/user/nuevo-activo-fijo/0'
                        },
                        {
                            id: 'lista-activo-fijo',
                            title: 'Inventario Activos Fijos',
                            type: 'item',
                            icon: icoMenu.InventoryIcon,
                            url: '/user/lista-activo-fijo'
                        },
                        {
                            id: 'depreciacion-activo-fijo',
                            title: 'Depreciacion Activos Fijos',
                            type: 'item',
                            icon: icoMenu.ReportGmailerrorredIcon,
                            url: '/user/depreciacion-activo-fijo'
                        },
                    ]
                },
                {
                    id: 'bancos',
                    title: 'Bancos',
                    type: 'collapse',
                    icon: icoMenu.AccountBalanceIcon,
                    children: [
                        {
                            id: 'conciliacion-bancarias',
                            title: 'Conciliaciones Bancarias',
                            type: 'item',
                            icon: icoMenu.JoinInnerIcon,
                            url: '/user/conciliacion-bancaria'
                        },
                        {
                            id: 'depositos-bancarios',
                            title: 'Depositos',
                            type: 'item',
                            icon: icoMenu.SavingsIcon,
                            url: '/user/depositos-clientes-view'
                        },
                        {
                            id: 'depositos-validar-ventas',
                            title: 'Depositos Ventas',
                            type: 'item',
                            icon: icoMenu.SavingsIcon,
                            url: '/user/depositos-validar-ventas-view'
                        },
                        {
                            id: 'lista-depositos',
                            title: 'Lista depósitos',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/lista-depositos-view'
                        },
                        {
                            id: 'recibos-cobro-depositos',
                            title: 'Recibos de cobro',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/lista-cobros-clientes-view'
                        },
                    ]
                },
                {
                    id: 'roles',
                    title: 'Roles',
                    type: 'collapse',
                    icon: icoMenu.AccessibilityIcon,
                    children: [
                        {
                            id: 'nuevo_rol',
                            title: 'Ficha Rol',
                            type: 'item',
                            url: '/user/nuevo-empleado/0'
                        },
                        {
                            id: 'lista_rol',
                            title: 'Lista Ficha Rol',
                            type: 'item',
                            url: '/user/list-empleados'
                        },
                        {
                            id: 'nuevo_tipo_egreso_ingreso_empleados',
                            title: 'Nuevo Rol Tipo Egreso',
                            type: 'item',
                            url: '/user/nuevo-tipo-egreso-empleado/0'
                        },
                        {
                            id: 'lista_rol_tipo_ingresos_egresos',
                            title: 'Lista Rol Tipo Egreso',
                            type: 'item',
                            url: '/user/list-rol-egresos-empleados'
                        },
                        {
                            id: 'rol_ingresos_egresos_consolidado',
                            title: 'Carga Ingresos/Egresos Rol',
                            type: 'item',
                            url: '/user/rol-ingresos-egresos-consolidado'
                        },
                        {
                            id: 'lista_rol_pagos',
                            title: 'Rol de pagos',
                            type: 'item',
                            url: '/user/list-rol-de-pagos'
                        }                        
                    ]
                },
                {
                    id: 'EfectivoyEquivalentesMenu',
                    title: 'Efectivo y Equivalentes',
                    type: 'collapse',
                    icon: icoMenu.LocalAtmIcon,
                    children: [
                        {
                            id: 'cajas',
                            title: 'Cajas',
                            type: 'collapse',
                            icon: icoMenu.AttachMoneyIcon,
                            children: [
                                {
                                    id: 'nueva_caja',
                                    title: 'Nueva Caja',
                                    type: 'item',
                                    url: '/user/new-cajas/0'
                                },
                                {
                                    id: 'lista_cajas',
                                    title: 'Lista Cajas',
                                    type: 'item',
                                    url: '/user/list-cajas-view'
                                },                
                            ]
                        },
                        {
                            id: 'bancos',
                            title: 'Bancos',
                            type: 'collapse',
                            icon: icoMenu.AccountBalanceIcon,
                            children: [
                                {
                                    id: 'nuevo_banco',
                                    title: 'Nuevo Banco',
                                    type: 'item',
                                    url: '/user/new-bancos/0'
                                },
                                {
                                    id: 'lista_bancos',
                                    title: 'Lista Bancos',
                                    type: 'item',
                                    url: '/user/list-bancos-view'
                                },                
                            ]
                        },      
                        {
                            id: 'tarjetas_credito',
                            title: 'Tarjetas Crédito',
                            type: 'collapse',
                            icon: icoMenu.CreditCardIcon,
                            children: [
                                {
                                    id: 'nueva_tarjeta',
                                    title: 'Nueva Tarjeta',
                                    type: 'item',
                                    url: '/user/new-tarjetas/0'
                                },
                                {
                                    id: 'lista_tarjetas',
                                    title: 'Lista Tarjetas',
                                    type: 'item',
                                    url: '/user/list-tarjetas'
                                },                
                            ]
                        },                  
                        {
                            id: 'tipos_movimientos',
                            title: 'Tipos de Movimientos',
                            type: 'collapse',
                            icon: icoMenu.CompareArrowsIcon,
                            children: [
                                {
                                    id: 'nuevo_tipo_movimiento_caja',
                                    title: 'Nuevo Tipo Movimiento Caja',
                                    type: 'item',
                                    url: '/user/new-tipo-movimiento-caja/0'
                                },
                                {
                                    id: 'lista_tipo_movimiento_caja',
                                    title: 'Lista Tipo Movimiento Caja',
                                    type: 'item',
                                    url: '/user/list-tipo-movimiento-caja-view'
                                },
                                {
                                    id: 'nuevo_tipo_movimiento_banco',
                                    title: 'Nuevo Tipo Movimiento Banco',
                                    type: 'item',
                                    url: '/user/new-tipo-movimiento-bancos/0'
                                },
                                {
                                    id: 'lista_tipo_movimiento_banco',
                                    title: 'Lista Tipo Movimiento Banco',
                                    type: 'item',
                                    url: '/user/list-tipo-movimiento-bancos-view'
                                },
                            ]
                        },
                        {
                            id: 'movimientos_caja',
                            title: 'Movimientos de Caja',
                            type: 'collapse',
                            icon: icoMenu.CompareArrowsIcon,
                            children: [
                                {
                                    id: 'nuevo_movimiento_caja',
                                    title: 'Nuevo Movimiento Caja',
                                    type: 'item',
                                    url: '/user/new-movimientos-caja/0'
                                },
                                {
                                    id: 'lista_movimientos_caja',
                                    title: 'Lista Movimientos Caja',
                                    type: 'item',
                                    url: '/user/list-movimientos-caja-view'
                                },                
                            ]
                        },
                        {
                            id: 'movimientos_banco',
                            title: 'Movimientos de Banco',
                            type: 'collapse',
                            icon: icoMenu.CompareArrowsIcon,
                            children: [
                                {
                                    id: 'nuevo_movimiento_banco',
                                    title: 'Nuevo Movimiento Banco',
                                    type: 'item',
                                    url: '/user/new-movimientos-bancos/0'
                                },
                                {
                                    id: 'lista_movimientos_banco',
                                    title: 'Lista Movimientos Banco',
                                    type: 'item',
                                    url: '/user/list-movimientos-bancos-view'
                                },                
                            ]
                        },
                    ]
                }
            ]
        }     
    ]
};

export default contabilidad;
